/**
 * Inline-edit popover for header ID fields.
 *
 * Usage (HTML):
 *   <button type="button" id="myField" class="btn btn-sm btn-outline-secondary text-nowrap"
 *       title="Edit Field Label"
 *   ><i class="fa-solid fa-pen-to-square"></i> <span data-inline-edit-value>current value</span></button>
 *
 * Usage (JS, from inline <script> after the element):
 *   window.inlineEdit.register(document.getElementById('myField'), {
 *       maxlength: 15,
 *       placement: 'bottom',
 *       onSave: function(value, done, fail) {
 *           $.post('/ajax/endpoint.cfm', { ... })
 *             .done(function(data) {
 *                 if (ok) done(savedValue);
 *                 else fail('Error message');
 *             });
 *       }
 *   });
 */

let counter = 0;

function buildPopoverContent(inputId, maxlength) {
    const maxlengthAttr = maxlength ? ` maxlength="${maxlength}"` : '';
    return `<div class="d-flex align-items-center gap-1">
        <input type="text" class="form-control form-control-sm"${maxlengthAttr}
            id="${inputId}" />
        <button type="button" class="btn btn-sm btn-success btn-icon-only"
            data-action="save" title="Save"><i class="fa-solid fa-check"></i></button>
        <button type="button" class="btn btn-sm btn-secondary btn-icon-only"
            data-action="cancel" title="Cancel"><i class="fa-solid fa-xmark"></i></button>
    </div>
    <div data-inline-edit-status class="small mt-1"></div>`;
}

function register(el, config) {
    if (!el) return;

    const inputId = `inline-edit-input-${++counter}`;
    const maxlength = config.maxlength;
    const placeholder = el.getAttribute('data-inline-edit-placeholder') || '';

    const popover = new bootstrap.Popover(el, {
        html: true,
        sanitize: false,
        trigger: 'click',
        placement: config.placement || 'bottom',
        content: buildPopoverContent(inputId, maxlength),
    });

    el.addEventListener('shown.bs.popover', function () {
        const input = document.getElementById(inputId);
        const popoverEl = document.querySelector('.popover');
        if (!input || !popoverEl) return;

        // Sync value from trigger's display span (ignore placeholder content)
        const valSpan = el.querySelector('[data-inline-edit-value]');
        if (valSpan) {
            const isPlaceholder = valSpan.querySelector('.text-muted') !== null;
            input.value = isPlaceholder ? '' : valSpan.textContent.trim();
        }

        input.focus();
        input.select();

        const statusEl = popoverEl.querySelector('[data-inline-edit-status]');

        function doSave() {
            if (!config.onSave) return;
            config.onSave(
                input.value,
                function (savedValue) {
                    if (valSpan) {
                        if (savedValue && savedValue.trim()) {
                            valSpan.textContent = savedValue;
                        } else {
                            valSpan.innerHTML = placeholder
                                ? '<span class="text-muted">' + placeholder + '</span>'
                                : '';
                        }
                    }
                    popover.hide();
                },
                function (errorMsg) {
                    if (statusEl) {
                        statusEl.textContent = errorMsg;
                        statusEl.classList.add('text-danger');
                    }
                }
            );
        }

        function doCancel() {
            popover.hide();
        }

        popoverEl
            .querySelector('[data-action="save"]')
            .addEventListener('click', doSave);
        popoverEl
            .querySelector('[data-action="cancel"]')
            .addEventListener('click', doCancel);

        input.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                doSave();
            }
            if (e.key === 'Escape') {
                e.preventDefault();
                doCancel();
            }
        });

        // Click outside to dismiss
        function onClickOutside(e) {
            if (
                popoverEl &&
                !popoverEl.contains(e.target) &&
                !el.contains(e.target)
            ) {
                popover.hide();
            }
        }
        setTimeout(function () {
            document.addEventListener('mousedown', onClickOutside);
        }, 0);

        el.addEventListener(
            'hidden.bs.popover',
            function cleanup() {
                document.removeEventListener('mousedown', onClickOutside);
                el.removeEventListener('hidden.bs.popover', cleanup);
            }
        );
    });
}

window.inlineEdit = { register };
